export default __webpack_public_path__ + "static/media/report-robo-16px.b5bf3e6c.svg";